export interface Slide {
  readonly id: number;
  readonly type: 'image' | 'video';
  readonly src: string;
  readonly srcMobile?: string;
  readonly alt: string;
  readonly topline: string;
  readonly title: string;
  readonly subtitle: string;
  readonly primaryCta: string;
  readonly primaryCtaLink: string;
  readonly secondaryCta: string;
  readonly secondaryCtaLink: string;
}

export const slides: readonly Slide[] = [
  {
    id: 5,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner5.jpg',
    srcMobile: '/images/pages/home/hero/mobile/hero-banner5.jpg',
    alt: 'A collection of pet jars in various shapes and sizes.',
    topline: 'Pet Jars',
    title: 'Versatile PET jars for a wide range of products.',
    subtitle: 'Our pet jars offer a convenient and safe way for your furry friends to enjoy their favorite drinks.',
    primaryCta: 'Shop Pet Jars',
    primaryCtaLink: '/products/pet-jars',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  },
  {
    id: 4,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner4.jpg',  
    srcMobile: '/images/pages/home/hero/mobile/hero-banner4.jpg',
    alt: 'A collection of cans in various shapes and sizes.',
    topline: 'Beverage Cans',
    title: 'A Variety of Tastes and Sizes',
    subtitle: 'Our beverage cans are available in a range of flavors and sizes, perfect for any occasion.',
    primaryCta: 'Shop Beverage Cans',
    primaryCtaLink: '/products/pet-cans',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  },
  {
    id: 2,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner2.jpg',
    srcMobile: '/images/pages/home/hero/mobile/hero-banner2.jpg',
    alt: 'A display of fridge bottles in various colors and sizes.',
    topline: 'Fridge Bottles',
    title: 'BPA-free Fridge Bottles ',
    subtitle: 'Our fridge bottles are perfect for staying hydrated and cooling down in the summer and winter.',
    primaryCta: 'Shop Fridge Bottles',
    primaryCtaLink: '/products/fridge-bottles',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  },
  {
    id: 1,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner1.jpg',
    srcMobile: '/images/pages/home/hero/mobile/hero-banner1.jpg',
    alt: 'A collection of pet bottles showcasing different sizes and shapes.',
    topline: 'Pet Bottles',
    title: 'BPA-free leak-proof Pet Bottles',
    subtitle: 'Our pet bottles are designed to provide your furry friends with the ultimate beverage experience.',
    primaryCta: 'Shop Pet Bottles',
    primaryCtaLink: '/products/pet-bottles',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  },
  {
    id: 3,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner3.jpg',
    srcMobile: '/images/pages/home/hero/mobile/hero-banner3.jpg',
    alt: 'A collection of kid-friendly water bottles in bright colors.',
    topline: 'Kids Water Bottles',
    title: 'Safe and Fun for Little Ones',
    subtitle: 'Our kid-friendly water bottles ensure a safe and enjoyable beverage experience for kids of all ages.',
    primaryCta: 'Shop Kids Water Bottles',
    primaryCtaLink: '/products/kids-water-bottles',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  },
  {
    id: 6,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner6.jpg',
    srcMobile: '/images/pages/home/hero/mobile/hero-banner6.jpg',
    alt: 'Pet Preforms ',
    topline: 'Pet Preforms',
    title: 'Vergin Pet Preforms ',
    subtitle: 'Our pet preforms offer a convenient and portable way for your furry friends to enjoy their favorite drinks on the go.',
    primaryCta: 'Shop Pet Preforms',
    primaryCtaLink: '/products/pet-preforms',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  },
  {
    id: 7,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner7.jpg',
    srcMobile: '/images/pages/home/hero/mobile/hero-banner7.jpg',
    alt: 'Sealing Machine',
    topline: 'Sealing Machine',
    title: 'Precision and Efficiency',
    subtitle: 'Our sealing machine ensures a precise and efficient sealing process, producing perfectly sealed containers.',
    primaryCta: 'Shop Sealing Machine',
    primaryCtaLink: '/products/can-sealing-machine',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  },
  {
    id: 8,
    type: 'image',
    src: '/images/pages/home/hero/hero-banner8.jpg',
    srcMobile: '/images/pages/home/hero/mobile/hero-banner8.jpg',
    alt: 'can lid and can cover',
    topline: 'Can Lid and Can Cover',
    title: 'A Portable and Convenient Option',
    subtitle: 'Our can lid and can cover offer a convenient and portable way for your furry friends to enjoy their favorite drinks on the go.',
    primaryCta: 'Shop Can Lid and Can Cover',
    primaryCtaLink: '/products/can-lid-and-can-cover',
    secondaryCta: 'Explore More',
    secondaryCtaLink: '/products',
  }
] as const;
